import { Link } from 'react-router-dom';

export default function ArticleEntry() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-6xl mx-auto">
          <div className="flex-1 w-full">
            <div className="relative w-full h-[300px] md:h-[380px] rounded-[32px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20minimalist%20workspace%20with%20a%20macbook%20displaying%20colorful%20spreadsheet%20charts%20on%20screen%20next%20to%20a%20ceramic%20coffee%20mug%20and%20a%20small%20potted%20succulent%20plant%20on%20a%20warm%20oak%20wooden%20desk%20soft%20morning%20sunlight%20streaming%20through%20sheer%20linen%20curtains%20scandinavian%20home%20office%20aesthetic%20calm%20productive%20atmosphere%20editorial%20photography%20high%20detail%20film%20grain%20warm%20neutral%20tones&width=1000&height=800&seq=article-entry-v2&orientation=squarish"
                alt="Przewodnik Kakobuy Spreadsheet"
                title="Kakobuy Spreadsheet – kompletny przewodnik"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
              Przewodnik
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Kompletny Przewodnik{' '}
              <span className="italic text-primary-500">Kakobuy Spreadsheet</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              Dowiedz się wszystkiego o <strong>Kakobuy Spreadsheet</strong> — jak efektywnie korzystać z arkusza produktów, 
              jak znaleźć najlepsze okazje i jak porównywać ceny między kategoriami. Nasz przewodnik pomoże Ci 
              maksymalnie wykorzystać potencjał <strong>Kakobuy Finds</strong> i zaoszczędzić czas podczas zakupów online.
            </p>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
              Niezależnie od tego, czy dopiero zaczynasz przygodę z <strong>Kakobuy Spreadsheet</strong>, 
              czy jesteś doświadczonym użytkownikiem — znajdziesz tu praktyczne porady, triki i strategie, 
              które pomogą Ci podejmować lepsze decyzje zakupowe.
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-3 mt-8">
              <Link
                to="/artykul-kakobuy-sheet"
                className="inline-flex items-center gap-3 px-6 py-3.5 bg-background-50 border border-background-300 rounded-xl text-sm font-semibold text-foreground-900 hover:bg-background-200 hover:border-primary-300 transition-all whitespace-nowrap cursor-pointer group"
              >
                <span>Przewodnik Kakobuy Sheet</span>
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </Link>
              <Link
                to="/porownanie-kakobuy-cssbuy"
                className="inline-flex items-center gap-3 px-6 py-3.5 bg-background-50 border border-background-300 rounded-xl text-sm font-semibold text-foreground-900 hover:bg-background-200 hover:border-primary-300 transition-all whitespace-nowrap cursor-pointer group"
              >
                <span>Porównanie Kakobuy vs CSSBuy</span>
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </Link>
              <Link
                to="/bezpieczenstwo-kakobuy"
                className="inline-flex items-center gap-3 px-6 py-3.5 bg-background-50 border border-background-300 rounded-xl text-sm font-semibold text-foreground-900 hover:bg-background-200 hover:border-primary-300 transition-all whitespace-nowrap cursor-pointer group"
              >
                <span>Przewodnik bezpieczeństwa</span>
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}